import { AdvancedComponent } from './advanced.component';
import {Routes, RouterModule} from '@angular/router';
import { NgModule } from '@angular/core';



const routes : Routes = [
    {
    path: '',
    component: AdvancedComponent
    }
];

@NgModule({
imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})

export class AdvancedRoutingModule {}